module.exports = __webpack_public_path__ + "assets/img/36_503_big.80938bf8.jpg";